import React, { createContext, useContext, useEffect, useState } from 'react';
import './PopupProvider.css';

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const originalAlert = window.alert;

    window.alert = (nextMessage) => {
      setMessage(String(nextMessage || 'Something went wrong.'));
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []);

  return (
    <PopupContext.Provider value={{ showPopup: (nextMessage) => setMessage(nextMessage) }}>
      {children}
      {message ? (
        <div className="app-popup-backdrop" role="presentation">
          <section className="app-popup" role="alertdialog" aria-modal="true" aria-labelledby="app-popup-title">
            <h2 id="app-popup-title">Notification</h2>
            <p>{message}</p>
            <button type="button" className="btn btn-primary" onClick={() => setMessage('')}>
              OK
            </button>
          </section>
        </div>
      ) : null}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
